define('app/sdc/md/hide/sdc-md-hide',["$parse", "factory!sdc-md-attribute"], function ($parse, mdAttributeFactory) {
	"use strict";
	return mdAttributeFactory("hide",
		function mdHideFormatter(value) {
			if (!value) {
				value = {
					"default": true
				};
			}
			else if (!angular.isObject(value)) {
				value = {
					"gt-sm": value,
					"default": true
				}
			}
			return value;
		});
});
